import { render, staticRenderFns } from "./Selectedpop.vue?vue&type=template&id=1cb38e40"
import script from "./Selectedpop.vue?vue&type=script&lang=js"
export * from "./Selectedpop.vue?vue&type=script&lang=js"
import style0 from "./Selectedpop.vue?vue&type=style&index=0&id=1cb38e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports